var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionRequiredRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.25,
    fill: "#E2574C",
    stroke: "#E2574C",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9963 10.6543V8.47266",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9957 12.4046C10.9152 12.4046 10.8498 12.47 10.8504 12.5505C10.8504 12.631 10.9158 12.6963 10.9963 12.6963C11.0768 12.6963 11.1421 12.631 11.1421 12.5505C11.1421 12.47 11.0768 12.4046 10.9957 12.4046",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1872 5.41583L16.6549 13.2348C17.1741 14.1437 16.5179 15.2747 15.4714 15.2747H6.53585C5.48877 15.2747 4.83252 14.1437 5.35227 13.2348L9.82002 5.41583C10.3433 4.49941 11.6639 4.49941 12.1872 5.41583Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionRequiredRed);
export default __webpack_public_path__ + "static/media/actionRequiredRed.14bd9f38.svg";
export { ForwardRef as ReactComponent };